import React from 'react';
const LoadingSpinner = () => {
    return (React.createElement("div", { className: 'loading' },
        React.createElement("div", { className: 'spinner' }),
        React.createElement("p", null, "Loading...")));
};
export default LoadingSpinner;
